<template>
<div class="chapter">
<div class="inner_page">
<p class="orna1"><img alt="The Crusader States" src="images/ornament.jpg"/></p>
<h2 class="prect"><a id="pVI"></a><a id="pVII">Contents</a></h2><a id="pVII">
</a><p class="contents"><a id="pVII">  </a><a href="#/007List_of_Illustrations"><i>List of Illustrations</i></a></p>
<p class="contents">  <a href="#/008Preface"><i>Preface</i></a></p>
<p class="linespace">
</p><p class="contents">  <a href="#/009Introduction">Introduction</a></p>
<p class="contents"><a href="#/0101_The_Expedition_to_Jerusalem">1 The Expedition to Jerusalem</a></p>
<p class="contents"><a href="#/0112_Syria_and_Palestine">2 Syria and Palestine</a></p>
<p class="contents"><a href="#/0123_The_First_Settlers">3 The First Settlers</a></p>
<p class="contents"><span href="#/0134_The_Origins_of_the_Latin_States" title="Link target outside of Sample">4 The Origins of the Latin States</span></p>
<p class="contents"><span href="#/0145_The_Military_Institutional_and_Ecclesiastical_Framework" title="Link target outside of Sample">5 The Military, Institutional and Ecclesiastical Framework</span></p>
<p class="contents"><span href="#/0156_Antioch_and_Jerusalem" title="Link target outside of Sample">6 Antioch and Jerusalem</span></p>
<p class="contents"><span href="#/0167_The_Second_Generation" title="Link target outside of Sample">7 The Second Generation</span></p>
<p class="contents"><span href="#/0178_The_Zengid_Threat" title="Link target outside of Sample">8 The Zengid Threat</span></p>
<p class="contents"><span href="#/0189_The_Frankish_Imprint" title="Link target outside of Sample">9 The Frankish Imprint</span></p>
<p class="contents"><span href="#/01910_King_Amalric" title="Link target outside of Sample">10 King Amalric</span></p>
<p class="contents"><span href="#/02011_The_Disintegration_of_the_Crusader_States" title="Link target outside of Sample">11 The Disintegration of the Crusader States</span></p>
<p class="contents"><span href="#/02112_The_Battle_of_Hattin_and_its_Consequences" title="Link target outside of Sample">12 The Battle of Hattin and its Consequences</span></p>
<p class="contents"><span href="#/02213_The_Third_Crusade" title="Link target outside of Sample">13 The Third Crusade</span></p>
<p class="contents">  <span href="#/023Conclusion" title="Link target outside of Sample">Conclusion</span></p>
<p class="linespace">
</p><p class="contents">  <span href="#/024Chronology" title="Link target outside of Sample"><i>Chronology</i></span></p>
<p class="contents">  <span href="#/025Abbreviations" title="Link target outside of Sample"><i>Abbreviations</i></span></p>
<p class="contents">  <span href="#/026Notes" title="Link target outside of Sample"><i>Notes</i></span></p>
<p class="contents">  <span href="#/027Further_Reading" title="Link target outside of Sample"><i>Further Reading</i></span></p>
<p class="contents">  <span href="#/028Bibliography" title="Link target outside of Sample"><i>Bibliography</i></span></p>
<p class="contents">  <span href="#/029Index" title="Link target outside of Sample"><i>Index</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 006Contents.vue?0fc93c3c